import { render, staticRenderFns } from "./comment.vue?vue&type=template&id=6dea1dda&scoped=true&"
import script from "./comment.vue?vue&type=script&lang=js&"
export * from "./comment.vue?vue&type=script&lang=js&"
import style0 from "./comment.vue?vue&type=style&index=0&id=6dea1dda&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dea1dda",
  null
  
)

export default component.exports